
import { IGetNursingHomeResponse, IGetNursingHomesResponse, INursingHome, SELECTED_NURSING_HOME_ID } from "@source/api/models/nursingHomeModels";
import { HousesTableData } from "@source/utils/models/adminModels";
import { makeAutoObservable } from "mobx";
import {IResident} from "@source/api/models/residentModel";

class NursingHomeStore {
  nursingHomes: INursingHome[] = [];
  nursingHomesTotalCount: number = 0;
  adminNursingHomes: INursingHome[] = [];
  adminNursingHomesTotalCount: number = 0;
  activeNursingHome: INursingHome | null = null;
  editedNursingHome: INursingHome | null = null;
  focusNursingHome: INursingHome | null = null;
  focusNursingHomePage: number | null = null;
  isEditNursingHome: boolean = false;
  name: string = '';
  address: string = '';
  newResidents: IResident[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  private formatAadminNusringHome(nursingHome: INursingHome): HousesTableData {
    const {accessKeys, photo, email, address, _id, name, phone} = nursingHome;
    
    const formatedNursingHome = {
      name,
      address,
      _id,
      email,
      photo,
      accessKeys,
      phone,
      actions: null,
    }

    return formatedNursingHome;
  }

  setFocusNursingHome(editedNursingHomeId: string | null) {
    this.focusNursingHome = this.adminNursingHomes.find((adminNursingHome) => adminNursingHome._id === editedNursingHomeId) || null;
  }

  getFocusNursingHome() {
    return this.focusNursingHome;
  }

  setFocusNursingHomePage(page: number | null) {
    this.focusNursingHomePage = page;
  }

  getFocusNursingHomePage() {
    return this.focusNursingHomePage;
  }

  getFormatedAdminHomes(): HousesTableData[] {
    return this.adminNursingHomes.map((employee) => {
      return this.formatAadminNusringHome(employee);
    })
  }

  editNursingHome(editedNursingHome: INursingHome) {
    if (this.activeNursingHome?._id === editedNursingHome._id) {
      this.activeNursingHome = editedNursingHome;
    }

    this.nursingHomes = this.nursingHomes.map(nursingHome => {
      if (nursingHome._id === editedNursingHome._id) {
        return {
          ...editedNursingHome,
        }
      }

      return {
        ...nursingHome,
      }
    })
  }

  setEditedNursingHome(editedNursingHome: HousesTableData | null) {
    this.editedNursingHome = this.adminNursingHomes.find((adminNursingHome) => adminNursingHome._id === editedNursingHome?._id) || null;
  }

  setNursingHomes(nursingHomesRes: IGetNursingHomesResponse) {
    this.nursingHomes = nursingHomesRes.nursingHomes;
    this.nursingHomesTotalCount = nursingHomesRes.totalCount;
  }

  setAdminNursingHomes(nursingHomesRes: IGetNursingHomesResponse) {
    this.adminNursingHomes = nursingHomesRes.nursingHomes;
    this.adminNursingHomesTotalCount = nursingHomesRes.totalCount;
  }

  setActiveNursingHome(nursingHome: INursingHome | null) {
    this.activeNursingHome = nursingHome;
  }

  setLocalStorageActiveNursingHome(nursingHomeId: string) {
    localStorage.setItem(SELECTED_NURSING_HOME_ID, nursingHomeId);
  }

  getLocalStorageActiveNursingHome() {
    return localStorage.getItem(SELECTED_NURSING_HOME_ID);
  }

  getId() {
    return this.activeNursingHome?._id || "";
  }

  getNursingHomeName(id: string) {
    return this.adminNursingHomes.find(home => home._id === id)?.name;
  }

  getActiveNursingHome() {
    return this.activeNursingHome;
  }

  getNursingHomes() {
    return this.adminNursingHomes;
  }

  getAdminNursingHomes() {
    return this.adminNursingHomes;
  }

  newResidentsActivatedModal() {
    return this.newResidents.length !== 0;
  }

  setNewResidents(residents: IResident[]) {
    this.newResidents = residents;
  }
}

export default new NursingHomeStore();
